<!--
 * @Author: M.D.
 * @Date: 2020-01-8 14:50:57
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="ca-o-w">
      <el-dialog
        :close-on-click-modal="false"
        class="ca-dia"
        ref="caDialog"
        @open="onOpen"
        @closed="onClose"
        :visible.sync="dialogShow"
        :width="dialogWidth">
        <div class="ca-header" slot="title">
          {{bindPhone ? '绑定手机' : '完善信息'}}
        </div>
        <div class="ca-form-w">

          <!-- 1st step -->
          <transition  name="t"  mode="out-in">
            <!-- <div class="t" key="1" v-if="bindPhone" style="height:100px;width:200px;background-color:red;">1</div>
            <div class="t" key="2" v-if="otherInfo" style="height:200px;width:200px;background-color:green;">2</div> -->

            <el-form class="t pb-form" key="b" ref="bPForm" v-if="bindPhone" :model="bPForm" label-position="right"  label-width="120px">
              <div class="tp-f-item">
                <el-form-item label="手机号码" class="u-pwd-phone" prop="phone" :rules="rule.phone">
                  <el-input placeholder="请输入手机号码" v-model="bPForm.phone"></el-input>
                </el-form-item>
              </div>
              <div class="tp-f-item">
                <el-form-item label="验证码" class="u-pwd-auth-c" prop="authCode" :rules="rule.required">
                  <auth-code ref="authCodeRef" :isReg="false" :phoneNum="bPForm.phone" @onReceving="onReceving" @authCodeChange="setNewAuthCode"></auth-code>
                </el-form-item>
              </div>
              <div class="tp-f-item" v-if="usrAccounts.length > 0">
                <el-form-item label="账号" class="u-pwd-auth-c" :rules="rule.required">
                  <el-select style="width: 100%" v-model="accountFromMobile" placeholder="请选择登录账号">
                    <el-option
                      v-for="item in usrAccounts"
                      :key="item.username"
                      :label="item.username"
                      :value="item.username">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <!-- <div class="tp-f-item">
                <el-form-item label="纳税人识别号" class="u-pwd-auth-c" prop="taxpayer" :rules="tpnValidator">
                  <el-input placeholder="请输入纳税人识别号" v-model="bPForm.taxpayer"/>
                </el-form-item>
              </div>
              <div class="tp-f-item">
                <el-form-item label="社会信用代码" class="u-pwd-auth-c" prop="socialCreditNo" :rules="scnValidator">
                  <el-input placeholder="请输入社会信用代码" v-model="bPForm.socialCreditNo"/>
                </el-form-item>
              </div> -->
            </el-form>

            <!-- 2nd step -->
            <el-form class="t ot-form" key="o" ref="oTForm" v-if="otherInfo" :model="oTForm" label-position="right"  label-width="120px">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="grid-content">
                    <el-form-item label="设置账户名" prop="usrName" :rules="rule.usrName">
                      <el-input placeholder="请设置账户名" v-model="oTForm.usrName"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content">
                    <el-form-item label="地区" prop="areaCode" :rules="rule.required">
                      <el-cascader :disabled="regionDisabled && !infoEditable" @change="getAreaTxt" v-model="oTForm.areaCode"
                      :props="{ checkStrictly: true }"
                      style="width: 100%"
                      :options="otOptions"></el-cascader>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="tp-f-item">
                    <el-form-item label="纳税人识别号" class="u-pwd-auth-c" prop="taxpayer" :rules="tpnValidator">
                      <el-input :disabled="!infoEditable" placeholder="请输入纳税人识别号" v-model="oTForm.taxpayer"/>
                    </el-form-item>
                  </div>
                </el-col>

                <el-col :span="12">
                  <div class="tp-f-item">
                    <el-form-item label="社会信用代码" class="u-pwd-auth-c" prop="socialCreditNo" :rules="scnValidator">
                      <el-input :disabled="!infoEditable" placeholder="请输入社会信用代码" v-model="oTForm.socialCreditNo"/>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="grid-content">
                    <el-form-item label="设置新密码" prop="pwd" :rules="rule.pwd">
                      <el-input type="password" show-password placeholder="请输入新密码（6-20个字符）" v-model="oTForm.pwd"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content">
                    <el-form-item label="确认密码" prop="repPwd" :rules="repPwdValidator">
                      <el-input placeholder="请再次输入新密码" type="password" show-password v-model="oTForm.repPwd"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>

              <el-row>
              <el-col>
                <!-- TODO: 用户协议连接 -->
                <el-checkbox v-model="oTForm.hasChkTrt" @change="onChkChange">请阅读并同意《用户服务协议》</el-checkbox>
              </el-col>
            </el-row>
            </el-form>
          </transition>
        </div>

        <div slot="footer" class="ca-footer">
          <transition name="fade" mode="out-in">
            <el-button style="width:40%" class="btn" v-if="bindPhone" type="primary" @click="toSecStep">{{ usrAccounts.length > 0 ? '登录' : '确定' }}</el-button>
            <el-button style="width:40%" class="btn" v-if="otherInfo" type="primary" @click="commitForm">完成</el-button>
          </transition>
          <el-button style="width:40%" v-if="usrAccounts.length > 0 && bindPhone" class="btn" type="primary" @click="registerStep">注册</el-button>
        </div>
      </el-dialog>
    <agreement cateId="11" @agrShowHandler="agrShowHandler" :agShow="agShow" />
  </div>
</template>

<script>
import rule from '@/util/rule'
import API from '@/api/api'
import { areaData, getAreaTxt } from '@/util/area'
import Agreement from '@/components/agreement'
import AuthCode from '@/components/auth-code'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    start: {
      type: Boolean,
      default: false
    },
    wxStateStr: {
      type: String,
      default: ''
    },
    newAccount: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      usrAccounts: [],
      accountFromMobile: '',
      rule,
      agShow: false,
      showDia: false,
      regionDisabled: false,
      // 1st step
      bindPhone: true,
      bPForm: {
        phone: '',
        authCode: ''
        // taxpayer: '',
        // socialCreditNo: ''
      },

      // 2nd step
      otherInfo: false,
      oTForm: {
        // phone: '',
        // authCode: '',
        usrName: '',
        areaCode: '',
        pwd: '',
        repPwd: '',
        taxpayer: '',
        socialCreditNo: '',
        hasChkTrt: false
      },
      otOptions: areaData,
      repPwdValidator: {
        required: true,
        validator: (rule, value, cb) => {
          if (!value) {
            return cb(new Error('确认密码不能为空'))
          } else if (this.oTForm.pwd !== value) {
            return cb(new Error('两次输入的密码不一致，请检查'))
          } else {
            cb()
          }
        },
        trigger: 'blur'
      },
      tpnValidator: {
        required: false,
        validator: (rule, value, cb) => {
          const reg = /^.{0,20}$/
          // if (!value) {
          //   return cb(new Error('纳税人识别号不能为空'))
          // } else
          if (value && !reg.test(value)) {
            return cb(new Error('请输入0-20位字符'))
          } else {
            cb()
          }
        },
        trigger: 'blur'
      },
      scnValidator: {
        required: false,
        validator: (rule, value, cb) => {
          const reg = /^.{0,20}$/
          // if (!value) {
          //   return cb(new Error('社会信用代码不能为空'))
          // } else
          if (value && !reg.test(value)) {
            return cb(new Error('请输入0-20位字符'))
          } else {
            cb()
          }
        },
        trigger: 'blur'
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    dialogShow: {
      get () {
        return this.start
      },
      set (v) {
        if (!v) {
          this.$emit('visChg', false)
        }
      }
    },
    infoEditable () {
      return this.userInfo && (this.userInfo.source !== 2)
    },
    dialogWidth () {
      return this.bindPhone ? '35%' : '57%'
    }
  },
  created () {

  },
  mounted () {

  },
  activated () {

  },
  deactivated () {

  },
  watch: {

  },
  methods: {
    ...mapActions(['loginSucc', 'setUserInfo']),
    async onReceving () {
      const res = await API.getMembersByMobile({
        mobile: this.bPForm.phone
      })
      if (res.data.statusCode === '200') {
        if (res.data.result.length === 0) {
          this.usrAccounts = []
        } else {
          this.usrAccounts = res.data.result
          this.accountFromMobile = this.usrAccounts[0].username
        }
      } else {
        this.usrAccounts = []
      }
    },
    perfectInfo () {
      // console.log('==============')
      // console.log(this.bindPhone)
      this.bindPhone = true
      this.otherInfo = false
    },
    showOtherInfo () {
      this.bindPhone = false
      this.otherInfo = true
    },
    agrShowHandler (v) {
      this.agShow = v
    },
    onOpen () {
      this.usrAccounts = []
      this.accountFromMobile = ''
      this.bPForm = {
        phone: this.userInfo.mobile || '',
        authCode: ''
        // taxpayer: this.userInfo.taxpayerNumber || '',
        // socialCreditNo: this.userInfo.creditCode || ''
      }
      this.oTForm = {
        // phone: '',
        // authCode: '',
        usrName: this.userInfo.username || '',
        areaCode: this.userInfo.areaCode || '',
        pwd: '',
        repPwd: '',
        taxpayer: this.userInfo.taxpayerNumber || '',
        socialCreditNo: this.userInfo.creditCode || '',
        hasChkTrt: false
      }
      if (this.bindPhone && this.$refs.authCodeRef) {
        this.$refs.authCodeRef.clearValue()
      }
      if (!this.wxStateStr) {
        this.regionDisabled = true
      }
    },
    onClose () {
      this.dialogShow = false
      // this.$emit('visChg', false)
    },
    onChkChange (v) {
      if (v) {
        this.agShow = true
      }
    },
    async registerStep () {
      console.log(this.wxStateStr)
      this.$refs.bPForm.validate(async bPFormRe => {
        if (!bPFormRe) {
          return
        }
        if (this.wxStateStr !== '') {
          API.qCBindPhone({
            mobile: this.bPForm.phone,
            code: this.bPForm.authCode,
            // taxpayerNumber: this.bPForm.taxpayer,
            // creditCode: this.bPForm.socialCreditNo,
            state: this.wxStateStr
          }).then(bpResponse => {
            if (bpResponse.data.statusCode === '200') {
              this.loginSucc(bpResponse).then(res => {
                this.$message({
                  message: '登录成功',
                  type: 'success'
                })
                this.dialogShow = false
                // this.$emit('visChg', false)
              })
            } else if (bpResponse.data.statusCode === '201') {
              this.register()
            } else if (bpResponse.data.statusCode === '202') {
              //
            } else {
              // close dialog
              this.dialogShow = false
              // this.$emit('visChg', false)
            }
          })
        } else {
          // 手机验证码
          const res = await API.validateCode({
            mobile: this.bPForm.phone,
            code: this.bPForm.authCode
          })
          if (res.data.statusCode === '200') {
            this.bindPhone = false
            this.otherInfo = true
          } else {
            this.$message(res.data.message)
          }
        }
      })
    },
    async toSecStep () {
      console.log(this.wxStateStr)
      this.$refs.bPForm.validate(async bPFormRe => {
        if (!bPFormRe) {
          return
        }
        if (this.wxStateStr !== '') {
          API.qCBindPhone({
            username: this.accountFromMobile || null,
            mobile: this.bPForm.phone,
            code: this.bPForm.authCode,
            // taxpayerNumber: this.bPForm.taxpayer,
            // creditCode: this.bPForm.socialCreditNo,
            state: this.wxStateStr
          }).then(bpResponse => {
            if (bpResponse.data.statusCode === '200') {
              this.loginSucc(bpResponse).then(res => {
                this.$message({
                  message: '登录成功',
                  type: 'success'
                })
                this.dialogShow = false
                // this.$emit('visChg', false)
              })
            } else if (bpResponse.data.statusCode === '201') {
              this.register()
            } else if (bpResponse.data.statusCode === '202') {
              //
            } else {
              // close dialog
              this.dialogShow = false
              // this.$emit('visChg', false)
            }
          })
        } else {
          // 手机验证码
          const res = await API.validateCode({
            mobile: this.bPForm.phone,
            code: this.bPForm.authCode
          })
          if (res.data.statusCode === '200') {
            this.bindPhone = false
            this.otherInfo = true
          } else {
            this.$message(res.data.message)
          }
        }
      })
    },
    register () {
      this.bindPhone = false
      setTimeout(() => {
        // 如果内容不为空则自动填写
        this.otherInfo = true
        this.oTForm.taxpayer = this.bPForm.taxpayer
        this.oTForm.socialCreditNo = this.bPForm.socialCreditNo
      }, 300)
    },
    async updateUserInfo () {
      // 修改
      const res = await API.updateCloudInfo({
        username: this.oTForm.usrName,
        password: this.oTForm.pwd,
        mobile: this.bPForm.phone
      })
      if (res.data.statusCode === '200') {
        this.$message({
          message: res.data.message,
          type: 'success'
        })
        // this.$store.dispatch('getMemberInfo')
        this.setUserInfo(res.data.result)
        this.dialogShow = false
        // this.$emit('visChg', false)
      } else {
        this.$message(res.data.message)
      }
    },
    setNewAuthCode (newVal) {
      this.bPForm.authCode = newVal
    },
    // 获取联级节点值
    getAreaTxt (v) {
      this.areaTxt = getAreaTxt(v)
      this.$refs.oTForm.validateField('areaCode') // 验证地区
    },
    // 提交完成
    commitForm () {
      this.$refs.oTForm.validate(async valid => {
        if (valid) {
          if (!this.oTForm.hasChkTrt) {
            this.$message({ message: '请同意用户服务协议', type: 'error' })
            return
          }

          // wxStateStr为空是修改信息
          if (this.wxStateStr === '') {
            this.updateUserInfo()
            return
          }
          let re = await API.qCCompAcct({
            username: this.oTForm.usrName,
            state: this.wxStateStr,
            password: this.oTForm.pwd,
            area: this.oTForm.areaCode[2] ? this.oTForm.areaCode[2] : '',
            city: this.oTForm.areaCode[1],
            province: this.oTForm.areaCode[0],
            region: this.areaTxt,
            taxpayerNumber: this.oTForm.taxpayer,
            creditCode: this.oTForm.socialCreditNo
          })
          if (re.data.statusCode === '200') {
            // this.$message({ message: '完善信息成功，请登录', type: 'success' })
            // this.$emit('toLogin')

            // this.loginSucc(re)
            // this.$message({
            //   message: '登录成功',
            //   type: 'success'
            // })
            // this.$emit('visChg', false)

            this.loginSucc(re).then(res => {
              this.$message({
                message: '登录成功',
                type: 'success'
              })
              this.dialogShow = false
              // this.$emit('visChg', false)
            })
          }
        }
      })
    }
  },
  components: {
    AuthCode, Agreement
  }
}
</script>

<style lang="stylus">
.ca-o-w
  .ca-dia
    .ca-header
      font-size 18px
      color theme-color
    .ca-form-w
      min-height 100px

      .t
        transition all .2s
      .t-enter, .t-leave-to
        opacity 0
        transform translate(30px)
      .t-enter-to
        opacity 1
        transform translate(0px)

    .ca-footer
      center()
</style>
